import DonationCategory from '@/core/components/DonationDetails/DonationCategory/DonationCategory';

export default DonationCategory;
